import axios from 'axios';
import { MenuItem } from '../domain/interfaces/cardapio';

const API_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:3000/api';

interface ItemResponse {
  id: string;
  name: string;
  description: string;
  price: number;
  category: string;
  newItem: boolean;
  available: boolean;
  flavors?: string[];
  imagePath?: string;
  imageUrl?: string;
}

export const fetchMenuItems = async (cnpj: string): Promise<MenuItem[]> => {
  const response = await axios.get<ItemResponse[]>(`${API_URL}/menu`, {
    params: { cnpj },
  });

  return response.data
    .filter((item) => item.available)
    .map<MenuItem>((item) => ({
      id: item.id,
      name: item.name,
      description: item.description,
      price: item.price,
      category: item.category,
      newItem: item.newItem,
      flavors: item.flavors ?? [],
      image: item.imageUrl,
    }));
};
